import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "expanded-tilat" }
const _hoisted_2 = { class: "expanded-header" }
const _hoisted_3 = { class: "header-info" }
const _hoisted_4 = {
  key: 0,
  class: "tasmennys-text"
}

import { HuonekorttiResponse } from "@/api/models/huonekortti-response"
import { LiiteResponse } from "@/api/models/liite-response"
import ComHuonekorttiTilatTable from "./ComHuonekorttiTilatTable.vue"
import ComHuonekorttiLiitteetTable from "./ComHuonekorttiLiitteetTable.vue"
import { useHuonekorttiTableWithDuplicates } from "./huonekorttiTable"
import { hankePage } from "@/views/hanke"


export default /*@__PURE__*/_defineComponent({
  __name: 'ComHuonekorttiExpandedRow',
  props: {
    row: {},
    liitteet: {},
    liitteetLoading: { type: Boolean }
  },
  emits: ["downloadLiite"],
  setup(__props: any) {

const { id: hankeId } = hankePage()
const { getDuplicateCount } = useHuonekorttiTableWithDuplicates(hankeId)





return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h4", null, _toDisplayString(__props.row.tilanimike?.nimi), 1),
        (__props.row.toiminta)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(__props.row.toiminta), 1))
          : _createCommentVNode("", true)
      ]),
      (_unref(getDuplicateCount)(__props.row) > 0)
        ? (_openBlock(), _createBlock(_component_el_tag, {
            key: 0,
            type: "warning",
            size: "small"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(getDuplicateCount)(__props.row)) + " duplikaattia ", 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_el_row, { gutter: 16 }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(ComHuonekorttiTilatTable, {
              tilat: __props.row.tilat ?? []
            }, null, 8, ["tilat"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(ComHuonekorttiLiitteetTable, {
              liitteet: __props.liitteet,
              loading: __props.liitteetLoading,
              onDownloadLiite: _cache[0] || (_cache[0] = (id) => _ctx.$emit('downloadLiite', id))
            }, null, 8, ["liitteet", "loading"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})